import React, { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

const ImageSlider = () => {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchImages = async () => {
    try {
      const response = await fetch(`${API_URL}/api/images/getall`);
      if (!response.ok) {
        throw new Error('Failed to fetch images');
      }

      const data = await response.json();

      const imageUrls = [
        data.image1Url,
        data.image2Url,
        data.image3Url,
        data.image4Url,
      ].filter(Boolean);

      setImages(imageUrls);
    } catch (err) {
      console.error('Error fetching images:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  // Auto-rotate every 5 seconds
  useEffect(() => {
    if (images.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval); 
  }, [images]);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  if (loading) return <div>Loading slider...</div>;
  if (error) return <div>Error: {error}</div>;
  if (images.length === 0) return <div>No images found.</div>;

  return (
      <div
  style={{
    position: 'relative',
    width: '100%',
    maxWidth: '1000px',
    height: '50vw', // responsive height
    maxHeight: '500px',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
  }}
>
  <img
    src={images[currentIndex]}
    alt={`Slide ${currentIndex}`}
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'opacity 0.5s ease-in-out',
    }}
  />


      {/* Previous Button */}
      <button
        onClick={goToPrev}
        style={{
          position: 'absolute',
          left: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.4)',
          border: 'none',
          color: 'white',
          fontSize: '2rem',
          cursor: 'pointer',
          padding: '0.5rem 1rem',
          borderRadius: '50%',
        }}
      >
        ‹
      </button>

      {/* Next Button */}
      <button
        onClick={goToNext}
        style={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.4)',
          border: 'none',
          color: 'white',
          fontSize: '2rem',
          cursor: 'pointer',
          padding: '0.5rem 1rem',
          borderRadius: '50%',
        }}
      >
        ›
      </button>
    </div>
  );
};

export default ImageSlider;
